import { useNavigate } from 'react-router-dom';

import signOutIcon from '@/assets/images/sign-out.png';
import { useConfirm } from '@/components/feedback/dialog';
import { useToast } from '@/components/feedback/toast';
import { routes } from '@/config/routes';
import { useLogout } from '@/features/auth';
import { UnauthorizedError } from '@/lib/api/errors';
import { useAuth } from '@/providers/auth-provider';

import { PROFILE_COPY } from './constants';
import styles from './use-sign-out.module.scss';

/** Sign Out behind a confirmation (117853 §13). A failed logout toasts and rethrows, which keeps
 *  the dialog open with the tokens intact (§13e); only a success clears the session. */
export function useSignOut() {
  const { confirm } = useConfirm();
  const toast = useToast();
  const logout = useLogout();
  const { clearSession } = useAuth();
  const navigate = useNavigate();

  return () =>
    void confirm({
      title: PROFILE_COPY.signOut.title,
      subtitle: PROFILE_COPY.signOut.body,
      confirmText: PROFILE_COPY.signOut.confirm,
      danger: false, // Figma 1705:710853 draws a black CTA; §1b's red is the menu item's
      icon: <img src={signOutIcon} alt="" aria-hidden="true" className={styles.icon} />,
      onConfirm: async () => {
        try {
          await logout.mutateAsync();
        } catch (error) {
          // A 401 here means the session is already dead and `sessionExpiry` toasts it; don't
          // double up. Rethrow either way so the dialog stays open (§13e).
          if (!(error instanceof UnauthorizedError)) {
            toast.error({ title: PROFILE_COPY.genericError });
          }
          throw error;
        }
        clearSession();
        navigate(routes.login, { replace: true });
      },
    });
}
